import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaHome, FaSignOutAlt } from 'react-icons/fa';
import Modal from 'react-bootstrap/Modal';
import Cookies from 'js-cookie';

const TopBar = ({ title, backPath }) => {
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    Cookies.remove('authToken');
    localStorage.clear();
    navigate('/');
  };

  return (
    <>
      <div className="app-topbar">
        {/* Back button or spacer */}
        {backPath ? (
          <button className="app-topbar-back" onClick={() => navigate(backPath)}>
            <FaArrowLeft />
          </button>
        ) : (
          <div style={{ width: 36 }} />
        )}

        {/* Title */}
        <p className="app-topbar-title">{title}</p>

        {/* Right: Home + Logout */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <button
            onClick={() => navigate('/Home')}
            title="Home"
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: 8,
              color: '#fff',
              width: 36,
              height: 36,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              fontSize: 17,
            }}
          >
            <FaHome />
          </button>
          <button
            onClick={() => setShowLogout(true)}
            title="Logout"
            style={{
              background: 'rgba(229,57,53,0.25)',
              border: 'none',
              borderRadius: 8,
              color: '#ff8a80',
              width: 36,
              height: 36,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              fontSize: 16,
            }}
          >
            <FaSignOutAlt />
          </button>
        </div>
      </div>

      {/* Logout confirm modal */}
      <Modal show={showLogout} onHide={() => setShowLogout(false)} centered>
        <Modal.Body style={{ padding: 0, borderRadius: 16, overflow: 'hidden' }}>
          <div style={{
            background: '#ffeaea', padding: '28px 24px 20px',
            textAlign: 'center', borderBottom: '1px solid #ffcccc',
          }}>
            <div style={{
              width: 60, height: 60, borderRadius: '50%',
              background: '#e53935', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 14px', fontSize: 22,
            }}>
              <FaSignOutAlt />
            </div>
            <p style={{ fontWeight: 700, fontSize: 17, color: '#c62828', margin: 0 }}>Logout?</p>
          </div>
          <div style={{ padding: '16px 24px 24px', textAlign: 'center' }}>
            <p style={{ fontSize: 13, color: '#666', marginBottom: 20 }}>
              Are you sure you want to logout from your account?
            </p>
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                onClick={() => setShowLogout(false)}
                style={{
                  flex: 1, height: 46, background: '#f0f0f0', color: '#444',
                  border: 'none', borderRadius: 10, fontWeight: 700, fontSize: 14, cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                style={{
                  flex: 1, height: 46, background: '#e53935', color: '#fff',
                  border: 'none', borderRadius: 10, fontWeight: 700, fontSize: 14, cursor: 'pointer',
                }}
              >
                Yes, Logout
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TopBar;
